module.exports = "<div id=\"{{id}}\" [ngClass]=\"cssClasses\" [ngStyle]=\"styles\">\n    <ng-content *ngIf=\"isOpened\"></ng-content>\n</div>\n";